import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkConfig } from "../../../../app/providers/StoreProvider";
import { USER_TOKEN_KEY } from "../../../../shared/lib/const/localstorage";
import { UserActions } from "../slices/UserSlice";
import { User } from "../..";


export const fetchRefreshToken = createAsyncThunk<User, void, ThunkConfig<string>>(
    'user/refreshToken',
    async (_, thunkApi) => {
        const { extra, rejectWithValue, dispatch } = thunkApi
        try {
            const response = await extra.api.post<User>(`/auth/renew_token`, {
                userToken: localStorage.getItem(USER_TOKEN_KEY)
            });

            dispatch(UserActions.setAuth(true))

            return response.data;
        } catch (e: any) {
            return rejectWithValue(e.message);
        } finally {
            dispatch(UserActions.initAuth())
        }
    },
);
